export const useLatestRequest = <Args, T = any>(
  customRequest: (abortControl: { signal: AbortSignal }, args: Args) => Promise<T>,
) => {
  let count = 0;
  let abortControl: AbortController | null = null;
  function abort() {
    if (abortControl) {
      abortControl.abort();
    }
    count++;
  }

  async function request(args: Args) {
    const currentCount = ++count;
    abortControl = new AbortController();
    const res = await customRequest({ signal: abortControl.signal }, args);
    abortControl = null;
    if (currentCount < count) {
      throw new Error('request is abandoned');
    }
    return res;
  }

  return { abort, request };
};
